export default {
  meta: {
    titleTemplate: '%s | FEIA'
  },
  brand: ' Forum économique international des Amériques',
  brandSmall: 'FEIA',
  nextEvent: 'Prochain événement',
  banner: 'Regardez le Toronto Global Forum en direct',
  navigation: {
    home: 'Accueil',
    events: 'Événements',
    allEvents: 'Tous les événements',
    eventNext: 'Voir le prochain événement',
    eventsNext: 'Prochains événements',
    eventsAnnual: 'Conférences',
    about: 'À propos',
    aboutUs: 'À propos',
    services: 'Services',
    team: 'Notre équipe',
    teamShort: 'Équipe',
    partner: 'Partenaire',
    becomePartner: 'Devenir partenaire',
    terms: "Conditions d'utilisation",
    privacy: 'Politique de confidentialité',
    consulting: 'Services de conseil',
    seeMore: 'Voir plus',
    gallery: 'Galerie de photos',
    galleryShort: 'Galerie',
    close: 'Fermer'
  },
  cta: {
    learnMore: 'En savoir plus',
    contact: 'Nous contacter',
    tickets: 'Billetterie',
    registerNow: "S'enregistrer maintenant"
  },
  city: {
    montreal: 'Montréal',
    toronto: 'Toronto',
    paris: 'Paris',
    miami: 'Miami',
    buenosAires: 'Buenos Aires',
    phoenix: 'Phoenix'
  },
  form: {
    name: 'Nom',
    email: 'Courriel',
    company: 'Entreprise',
    phone: 'Téléphone',
    subject: 'Sujet',
    getTouch: 'Prendre contact',
    partner: 'Devenir un partenaire',
    message: 'Message',
    button: 'Envoyer',
    tollFree: 'Sans frais'
  },
  copyright: 'Forum économique international des Amériques',
  cretedBy: 'Site web créé par',
  languages: {
    title: 'Langues',
    french: 'Français',
    english: 'Anglais',
    spanish: 'Espagnol'
  },
  buyTickets: 'Acheter des billets',
  logo: '/images/brand/logo-fr-white.png',
  logoSmall: '/images/brand/logo-small-fr-white.png',
  boardOfGovernors: 'Conseil des Gouverneurs',
  advisoryBoard: 'Comité aviseur',
  archives: 'Archives',
  ourPurpose: 'Notre objectif',
  pastEvents: 'Événements passés'
}
